/**
 * Centralized Debug Logging Service
 * Provides unified logging functionality for all tag editor services
 */

import { Injectable } from '@angular/core'

@Injectable({ providedIn: 'root' })
export class DebugLoggingService {
  private debugEnabled = false

  setDebugEnabled(enabled: boolean): void {
    this.debugEnabled = enabled
  }

  log(message: string, ...args: ReadonlyArray<unknown>): void {
    if (this.debugEnabled) {
      console.log(message, ...args)
    }
  }

  logWithService(serviceName: string, message: string, ...args: ReadonlyArray<unknown>): void {
    if (this.debugEnabled) {
      console.log(`[${serviceName}] ${message}`, ...args)
    }
  }
}
